import React, { useEffect, useState } from "react";
import Appointment from "./Appointment";
import Login from "./components/Login";
//import CustomerBookingApp from "./customer/CustomerBookingApp";
import PrivacyPolicy from "./components/PrivacyPolicy";
import {
  apiJson,
  clearAuthSession,
  getAuthToken,
  getStoredUser,
  setAuthSession,
  setUnauthorizedHandler
} from "./utils/api";

function App() {
  const [isCustomerBookingMode, setIsCustomerBookingMode] = useState(() => {
    if (typeof window === "undefined") return false;
    return String(window.location.hash || "").toLowerCase().startsWith("#book");
  });
  const [isPrivacyPolicyMode, setIsPrivacyPolicyMode] = useState(() => {
    if (typeof window === "undefined") return false;
    return String(window.location.hash || "").toLowerCase() === "#privacy-policy";
  });
  const [session, setSession] = useState(() => {
    const token = getAuthToken();
    const user = getStoredUser();
    if (!token || !user) return null;
    return { token, user };
  });

  const handleLogin = ({ token, user }) => {
    setAuthSession(token, user);
    setSession({ token, user });
    window.location.hash = "dashboard";
  };

  const handleLogout = () => {
    clearAuthSession();
    window.location.hash = "";
    setSession(null);
  };

  useEffect(() => {
    const handleHashMode = () => {
      const hash = String(window.location.hash || "").toLowerCase();
      setIsCustomerBookingMode(hash.startsWith("#book"));
      setIsPrivacyPolicyMode(hash === "#privacy-policy");
    };
    window.addEventListener("hashchange", handleHashMode);
    return () => {
      window.removeEventListener("hashchange", handleHashMode);
    };
  }, []);

  useEffect(() => {
    if (isCustomerBookingMode) return;
    setUnauthorizedHandler(() => {
      try {
        localStorage.setItem("dw-session-expired", "1");
      } catch {
        // Ignore storage errors
      }
      window.location.hash = "";
      setSession(null);
    });

    return () => {
      setUnauthorizedHandler(null);
    };
  }, [isCustomerBookingMode]);

  useEffect(() => {
    if (isCustomerBookingMode) return;
    const validateSession = async () => {
      if (!session?.token) return;
      try {
        const user = await apiJson("/api/auth/me", { timeoutMs: 10000 });
        setAuthSession(session.token, user);
        setSession({ token: session.token, user });
      } catch (err) {
        // Only force-logout on a confirmed 401 auth failure.
        // Timeouts and network errors in production (slow cold-starts,
        // container networking) must NOT clear a freshly-issued session.
        const isAuthFailure = err?.message && (
          err.message.includes("401") ||
          err.message.toLowerCase().includes("unauthorized") ||
          err.message.toLowerCase().includes("invalid credentials")
        );
        if (isAuthFailure) {
          clearAuthSession();
          setSession(null);
        }
        // Else: silently keep the existing session alive
      }
    };
    validateSession();
  }, [session?.token, isCustomerBookingMode]);

  if (isPrivacyPolicyMode) {
    return <PrivacyPolicy />;
  }

  /*if (isCustomerBookingMode) {
    return <CustomerBookingApp />;
  }*/

  return session
    ? <Appointment onLogout={handleLogout} currentUser={session.user} />
    : <Login onLogin={handleLogin} />;
}

export default App;